export default "/_next/static/site-0d922f218bc6871bd62b9541dfcf80c2.webmanifest";